import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridHeaderFilterFormDirective } from './grid-header-filter-form.directive';

@NgModule({
  declarations: [
    GridHeaderFilterFormDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    GridHeaderFilterFormDirective
  ]
})
export class GridHeaderFilterFormModule { }
